import { createSelector } from 'reselect';
import { selectLocations } from '../../locations/locations.selectors';
import { selectCurrentLocationId } from '../../current-location';

export const selectLocationFwdNumberIds = (locationId: string) =>
  createSelector(selectLocations, (locations) => locations[locationId]?.fwdNumberIds);

export const selectCurrentLocationFwdNumberIds = createSelector(
  selectLocations,
  selectCurrentLocationId,
  (locations, currentLocationId) => locations[currentLocationId]?.fwdNumberIds
);
